"use client"
import React, {useState, useEffect, useRef} from 'react';
import {MenuIcon, SearchIcon} from "lucide-react";
import {Button} from "@/components/ui/button";
import Image from "next/image";
import ElanzaLogoMobile from "@/public/logo/elanza-logo-mobile.svg";
import MobileMenuItems from "@/components/ui/menu/mobile-menu/component/mobile-menu-items";
import {usePathname} from "next/navigation";

/**
 *
 * @param data
 * @param categoriesProductCount
 * @constructor
 */
function MobileMenu({data , categoriesProductCount} : any) {
    const [open, setOpen] = useState<boolean>(false)
    const menuRef = useRef<HTMLDivElement>(null);
    const pathname = usePathname();
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        setOpen(false)
    }, [pathname]);

    if (!data) return null;

    return (
        <div className="!bg-transparent p-0 m-0" aria-label={"menu-mobile-button"}>
            <MenuIcon onClick={() => setOpen(!open)} className={`duration-200 ${open ? "rotate-90" : 'rotate-0'}`}/>
            <div
                ref={menuRef}
                className={`w-screen h-screen fixed top-0 z-[70] flex flex-wrap content-start bg-white ${open ? "left-0" : "left-full"}`}>
                <div className="w-full flex flex-wrap">
                    <header
                        className="w-full relative  flex md:hidden h-12 flex-wrap items-center justify-between px-[23px]">
                        <div className="w-1/4 flex items-center justify-start">
                            <MenuIcon onClick={() => setOpen(!open)}
                                      className={`duration-200 ${open ? "rotate-90" : 'rotate-0'}`}/>
                        </div>
                        <figure className="w-2/4 flex md:hidden items-center justify-center">
                            <Image src={ElanzaLogoMobile} alt={"elanza-logo"} title={"elanza-logo"} width={166} height={21}/>
                        </figure>
                        <div className="w-1/4 flex items-center justify-end">
                            <Button className="!bg-transparent p-0 m-0" aria-label={"search-mobile-button"}
                                    variant={"ghost"}>
                                <SearchIcon className='w-6 h-6'/>
                            </Button>
                        </div>
                    </header>
                </div>
                {open && <MobileMenuItems categoriesProductCount={categoriesProductCount} data={data?.categories} />}
            </div>
        </div>
    );
}

export default React.memo(MobileMenu);